/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav  .

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/


import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Schedule from "layouts/schedule";
import Events from "layouts/events";
import Clients from "layouts/clients";
import Leads from "layouts/leads"; // Certifique-se que src/layouts/leads/index.js existe


import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import Login from "auth/login";
import Register from "auth/register";
import ForgotPassword from "auth/forgot-password";
import ResetPassword from "auth/reset-password";

// @mui icons
import Icon from "@mui/material/Icon";
import { Navigate, useLocation } from "react-router-dom";



import ContractForm from "layouts/contracts/ContractForm";
import PremiumGate from "examples/PremiumGate";

function LegacyLeadsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/dashboard/pedidos${search}`} replace />;
}

const lockIcon = <Icon fontSize="small">lock</Icon>;

const generateRoutes = (user) => {
  // is_premium vem do /me (active ou lifetime). Enquanto o /me não chega, user é null:
  // nada de cadeado nem de tela premium para não piscar.
  const isPremium = Boolean(user?.is_premium);
  const isFree = Boolean(user) && !isPremium;

  // Free cai no PremiumGate (a tela real nem monta). Sem user ainda, não renderiza nada.
  const premiumOnly = (component, feature) => {
    if (!user) return null;
    return isPremium ? component : <PremiumGate feature={feature} />;
  };

  const routes = [
    {
      type: "examples",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "examples",
      name: "Perfil",
      key: "profile",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/profile",
      component: <Profile />,
    },
    {
      type: "collapse",
      name: "Pedidos",
      key: "leads",
      icon: <Icon fontSize="small">assignment_ind</Icon>,
      route: "/dashboard/pedidos",
      component: <Leads />,
    },
    {
      // Endereço antigo (links, favoritos): redireciona mantendo a query string
      type: "route",
      name: "Pedidos (antigo)",
      key: "leads-legacy",
      route: "/leads-disponiveis",
      component: <LegacyLeadsRedirect />,
    },
    {
      type: "collapse",
      name: "Agenda",
      key: "schedule",
      icon: isFree ? lockIcon : <Icon fontSize="small">schedule</Icon>,
      locked: isFree,
      route: "/schedule",
      component: premiumOnly(<Schedule />, "Agenda"),
    },
    {
      type: "collapse",
      name: "Eventos",
      key: "events",
      icon: isFree ? lockIcon : <Icon fontSize="small">event</Icon>,
      locked: isFree,
      route: "/events",
      component: premiumOnly(<Events />, "Eventos"),
    },
    {
      type: "collapse",
      name: "Clientes",
      key: "clients",
      icon: isFree ? lockIcon : <Icon fontSize="small">people</Icon>,
      locked: isFree,
      route: "/clients",
      component: premiumOnly(<Clients />, "Clientes"),
    },
    {
      // Contratos são acessados pelos eventos; o item existe para o menu mostrar o recurso
      type: "collapse",
      name: "Contratos",
      key: "contracts",
      icon: isFree ? lockIcon : <Icon fontSize="small">description</Icon>,
      locked: isFree,
      route: "/contratos",
      component: premiumOnly(<Navigate to="/events" replace />, "Contratos"),
    },
    {
      type: "route",
      name: "Contrato",
      key: "contract-form",
      route: "/contracts/event/:eventId",
      component: premiumOnly(<ContractForm />, "Contratos"),
    },

    {
      type: "collapse",
      name: "Meu Plano",
      key: "billing",
      icon: <Icon fontSize="small">workspace_premium</Icon>,
      route: "/billing",
      component: <Billing />,
    },
    {
      type: "route",
      name: "Notificações",
      key: "notifications",
      icon: <Icon fontSize="small">notifications</Icon>,
      route: "/notifications",
      component: <Notifications />,
    },
    {
      type: "route",
      name: "Sair",
      key: "sign-in",
      icon: <Icon fontSize="small">login</Icon>,
      route: "/authentication/sign-in",
      component: <SignIn />,
    },
    {
      type: "auth",
      name: "Login",
      key: "login",
      icon: <Icon fontSize="small">login</Icon>,
      route: "/auth/login",
      component: <Login />,
    },
    {
      type: "auth",
      name: "Register",
      key: "register",
      icon: <Icon fontSize="small">register</Icon>,
      route: "/auth/register",
      component: <Register />,
    },
    {
      type: "auth",
      name: "Forgot Password",
      key: "forgot-password",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: "/auth/forgot-password",
      component: <ForgotPassword />,
    },
    {
      type: "auth",
      name: "Reset Password",
      key: "reset-password",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: "/auth/reset-password",
      component: <ResetPassword />,
    },
  ];

  return routes;
};

export default generateRoutes;